module.exports = __webpack_public_path__ + "a90b0c1b43e1154f63449387c2ed5a1a.svg";